import * as React from "react";

/**
 * The bordered 32px box behind the TTN's inline fields — numeric inputs, the
 * hours + minutes duration and read-only metrics — so they line up as one row.
 */
export const FieldShell: React.FC<{
  /** Width classes; a fixed 120px by default. */
  className?: string;
  disabled?: boolean;
  /** Hover hint, e.g. where the value came from. */
  title?: string;
  children: React.ReactNode;
}> = ({ className, disabled, title, children }) => (
  <div
    title={title}
    className={`flex h-8 items-center gap-1 rounded-lg border border-border-primary bg-white px-2 focus-within:border-brand-blue ${
      className ?? "w-[120px] shrink-0"
    } ${disabled ? "opacity-60" : ""}`}
  >
    {children}
  </div>
);
